const { format, utcToZonedTime } = require('date-fns-tz')

export const formatDate = (date: Date | string | undefined) => {
  if (!date) return
  return date instanceof Date ? dateBr(date) : dateBr(new Date(date))
}

const dateBr = (date: Date) => {
  return format(date, 'dd/MM/yyyy')
}

export const hour = (date: Date) => {
  return format(date, 'HH:mm')
}

export const formatDateHour = (dateStr: string | undefined) => {
  if (!dateStr) return

  const date = new Date(dateStr)
  const dateFormatted = dateBr(date)
  const hourFormatted = hour(date)
  return `${dateFormatted} ${hourFormatted}`
}

export const formatPhoneNumber = (phone: string | undefined) => {
  if (!phone) return
  const digits = phone.replace(/\D/g, '')
  const country = digits.slice(0, 2)
  const ddd = digits.slice(2, 4)
  const number = digits.slice(4)
  if (number.length === 9) {
    return `+${country} (${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`
  }
  if (number.length === 8) {
    return `+${country} (${ddd}) ${number.slice(0, 4)}-${number.slice(4)}`
  }
  return `+${country} (${ddd}) ${number}`
}

export function formatDateTime(isoDate: Date) {
  const timeZone = 'America/Sao_Paulo'
  const zonedDate = utcToZonedTime(isoDate, timeZone)
  return format(zonedDate, 'dd/MM/yyyy - HH:mm', { timeZone })
}
